/* @flow */
import Entity from 'lib/Entity';
import type { DeliveryStatusType } from 'chat/constants/DeliveryConstants';

export type MessageDeliverySummaryUserType = {
  id: number,
  uuid: string,
  name: string,
  color: ?string,
  initials: ?string,
};

export default class MessageDeliverySummary extends Entity {
  initialize() {
    this.idAttribute = 'message_uuid';
  }

  getMessageType(): string {
    return this.get('message_type');
  }

  getState(): ?DeliveryStatusType {
    return this.get('state');
  }

  setState(state: DeliveryStatusType) {
    this.set('state', state);
  }

  getSuccessCount(): number {
    return this.get('success_count') || 0;
  }

  getReadCount(): number {
    return this.get('read_count') || 0;
  }

  getFailedCount(): number {
    return this.get('failed_count') || 0;
  }

  getTotalSent(): number {
    return this.getSuccessCount() + this.getReadCount() + this.getFailedCount();
  }

  getSteamUUID(): string {
    return this.get('stream_uuid');
  }

  getSuccessUsers(): MessageDeliverySummaryUserType[] {
    return this.get('success_users') || [];
  }

  getReadUsers(): MessageDeliverySummaryUserType[] {
    return this.get('read_users') || [];
  }

  getFailedUsers(): MessageDeliverySummaryUserType[] {
    return this.get('failed_users') || [];
  }
}



// WEBPACK FOOTER //
// ./src/entities/MessageDeliverySummary.js